import { render } from "./WebentwicklungDetails.vue?vue&type=template&id=05f80058&scoped=true"
import script from "./WebentwicklungDetails.vue?vue&type=script&lang=js"
export * from "./WebentwicklungDetails.vue?vue&type=script&lang=js"

import "./WebentwicklungDetails.vue?vue&type=style&index=0&id=05f80058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f80058"]])

export default __exports__